/**
 * Sublocalidad GBA → partido cabecera. Espejo de worker.js LOCALIDAD_TO_PARTIDO_BA.
 * Regenerar: node scripts/sync-gba-partido-map.mjs
 */
import { normalizeCtaCityKey } from "./geoHelpers.js";

export const GBA_SUBLOCALIDAD_TO_PARTIDO: Readonly<Record<string, string>> = {
  "villa tesei": "Hurlingham",
  "william morris": "Hurlingham",
  "castelar": "Morón",
  "haedo": "Morón",
  "el palomar": "Morón",
  "villa sarmiento": "Morón",
  "caseros": "Tres de Febrero",
  "santos lugares": "Tres de Febrero",
  "ciudadela": "Tres de Febrero",
  "saenz pena": "Tres de Febrero",
  "presidente saenz pena": "Tres de Febrero",
  "loma hermosa": "Tres de Febrero",
  "villa bosch": "Tres de Febrero",
  "pablo podesta": "Tres de Febrero",
  "olivos": "Vicente López",
  "florida": "Vicente López",
  "munro": "Vicente López",
  "la lucila": "Vicente López",
  "carapachay": "Vicente López",
  "villa adelina": "Vicente López",
  "martinez": "San Isidro",
  "beccar": "San Isidro",
  "acassuso": "San Isidro",
  "boulogne": "San Isidro",
  "boulogne sur mer": "San Isidro",
  "don torcuato": "Tigre",
  "benavidez": "Tigre",
  "pacheco": "Tigre",
  "general pacheco": "Tigre",
  "el talar": "Tigre",
  "villa ballester": "General San Martín",
  "jose leon suarez": "General San Martín",
  "san andres": "General San Martín",
  "muniz": "San Miguel",
  "bella vista": "San Miguel",
  "wilde": "Avellaneda",
  "sarandi": "Avellaneda",
  "dock sud": "Avellaneda",
  "pineyro": "Avellaneda",
  "gerli": "Avellaneda",
  "villa dominico": "Avellaneda",
  "lanus oeste": "Lanús",
  "remedios de escalada": "Lanús",
  "monte chingolo": "Lanús",
  "valentin alsina": "Lanús",
  "banfield": "Lomas de Zamora",
  "llavallol": "Lomas de Zamora",
  "turdera": "Lomas de Zamora",
  "ingeniero budge": "Lomas de Zamora",
  "don bosco": "Quilmes",
  "ezpeleta": "Quilmes",
  "san francisco solano": "Quilmes",
  "adrogue": "Almirante Brown",
  "burzaco": "Almirante Brown",
  "glew": "Almirante Brown",
  "longchamps": "Almirante Brown",
  "claypole": "Almirante Brown",
  "rafael calzada": "Almirante Brown",
  "jose marmol": "Almirante Brown",
  "ministro rivadavia": "Almirante Brown",
  "gonzalez catan": "La Matanza",
  "isidro casanova": "La Matanza",
  "san justo": "La Matanza",
  "ramos mejia": "La Matanza",
  "rafael castillo": "La Matanza",
  "gregorio de laferrere": "La Matanza",
  "villa madero": "La Matanza",
  "tablada": "La Matanza",
  "la tablada": "La Matanza",
  "lomas del mirador": "La Matanza",
  "ciudad evita": "La Matanza",
  "monte grande": "Esteban Echeverría",
  "luis guillon": "Esteban Echeverría",
  "el jaguel": "Esteban Echeverría",
  "9 de abril": "Esteban Echeverría",
  "tristan suarez": "Ezeiza",
  "canning": "Ezeiza",
  "carlos spegazzini": "Ezeiza",
  "hudson": "Berazategui",
  "villa espana": "Berazategui",
  "platanos": "Berazategui",
  "pereyra": "Berazategui",
  "gutierrez": "Berazategui",
  "bosques": "Florencio Varela",
  "los polvorines": "Malvinas Argentinas",
  "tortuguitas": "Malvinas Argentinas",
  "pablo nogues": "Malvinas Argentinas",
  "ing. pablo nogues": "Malvinas Argentinas",
  "ingeniero pablo nogues": "Malvinas Argentinas",
  "grand bourg": "Malvinas Argentinas",
  "del viso": "Pilar",
  "manzanares": "Pilar",
  "fatima": "Pilar",
  "manuel alberti": "Pilar",
  "villa rosa": "Pilar",
  "presidente derqui": "Pilar",
  "derqui": "Pilar",
  "garin": "Escobar",
  "matheu": "Escobar",
  "maquinista savio": "Escobar",
  "ingeniero maschwitz": "Escobar",
  "maschwitz": "Escobar",
  "belen de escobar": "Escobar",
  "guernica": "Presidente Perón",
  "mar de ajo": "La Costa",
  "santa teresita": "La Costa",
  "san bernardo": "La Costa",
  "mar del tuyu": "La Costa",
  "san clemente del tuyu": "La Costa",
  "las toninas": "La Costa",
  "trujui": "Moreno",
  "francisco alvarez": "Moreno",
  "la reja": "Moreno",
  "cuartel v": "Moreno",
  "paso del rey": "Moreno",
  "pontevedra": "Merlo",
  "mariano acosta": "Merlo",
  "libertad": "Merlo",
  "san antonio de padua": "Merlo"
} as const;

export function gbaPartidoForCity(city: string): string | null {
  const norm = normalizeCtaCityKey(city);
  if (!norm) return null;
  return GBA_SUBLOCALIDAD_TO_PARTIDO[norm] ?? null;
}

export function gbaSublocalidadEntries(): Array<{ sublocalidad: string; partido: string }> {
  return Object.entries(GBA_SUBLOCALIDAD_TO_PARTIDO).map(([sublocalidad, partido]) => ({
    sublocalidad,
    partido,
  }));
}
